<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Dashboard</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-chart-line me-1" style="color: #00A0C1;"></i>
                  Overview of browsing activity, uploads, and reported websites.
               </small>
            </div>
         </div>
      </div>

      <Dashboard />
   </div>
</template>

<script>
import Dashboard from '@/components/Dashboard/Dashboard.vue';

export default {
   components: {
      Dashboard,
   },
}
</script>

<style scoped>
.custom-span-lg {
   font-size: 24px;
   line-height: 24px;
   font-weight: bold;
}
</style>